import { createAnimation } from '@ionic/react';
import type {NavComponentWithProps } from '@ionic/react';

interface NavAnimationOptions {
  direction: 'forward' | 'back';
  enteringEl?: HTMLElement;
  leavingEl?: HTMLElement;
  baseEl?: HTMLElement;
  progressCallback?: ((step: number) => void) | undefined;
  duration?: number;
  animated?: boolean;
  mode?: string;
  keyboardClose?: boolean;
  deepWait?: boolean;
  viewIsReady?: (() => Promise<void>) | undefined;
  showGoBack?: boolean;
  goBackUrl?: string | undefined;
  nav?: NavComponentWithProps;
}

export const horizontalTransition = (_: HTMLElement, opts: NavAnimationOptions) => {
  const direction = opts.direction;
  const el = direction === 'forward' ? opts.enteringEl : opts.leavingEl;

  if (!el) return createAnimation();

  const animation = createAnimation()
    .addElement(el)
    .beforeRemoveClass('ion-page-invisible')
    .fromTo('transform', direction === 'forward' ? 'translateX(40px)' : 'translateX(0)', direction === 'forward' ? 'translateX(0)' : 'translateX(40px)')
    .fromTo('opacity', direction === 'forward' ? 0.01 : 1, direction === 'forward' ? 1 : 0.01);

  return createAnimation()
    .duration(300)
    .easing('ease-in-out')
    .addAnimation(animation);
};